import styles from 'modules/Billing/Billing.module.scss'
import { Icon } from 'gu-ui-kit'
import React from 'react'
import { useTranslation } from 'react-i18next'

const AdmitadWarning = () => {
  const { t } = useTranslation()

  return (
    <div className={styles['billing__warning']}>
      <Icon
        className={styles['billing__warning-icon']}
        name={'status warning'}
        color={'Interface-Orange-Primary'}
        width={14}
      />

      <span
        className={styles['billing__warning-summary']}
        dangerouslySetInnerHTML={{
          __html: t('billing::admitad_warning_message'),
        }}
      />
    </div>
  )
}

AdmitadWarning.propTypes = {}

export default AdmitadWarning
